import {StyleSheet} from 'react-native';

import platformConfig from '/config/platform.config';
import {cloudLightest, white} from '/theme/color/on.color';
import {denim} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  base: {
    backgroundColor: cloudLightest,
    width: '100%',
    paddingVertical: 10,
    marginVertical: 5,
  },
  scrollViewContainer: {
    maxHeight: 150,
  },
  modal: {
    backgroundColor: white,
    width: 500,
    height: '100vh' as any,
    margin: 0,
    alignSelf: 'flex-end',
  },
  modalView: {
    flex: 1,
    height: '100vh' as any,
    backgroundColor: white,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    paddingTop: 0,
  },
  modalHeader: {
    flexDirection: 'row',
    padding: 10,
    marginTop: 10,
  },
  headerText: {
    fontSize: 16,
    marginLeft: 10,
  },
  filterText: {
    fontSize: 15.5,
    marginLeft: 20,
    marginVertical: 10,
  },
  filterTextVal: {
    fontSize: 15,
    fontWeight: '400',
    marginTop: 10,
    marginRight: 5,
  },
  applyFiltersContainer: {
    fontSize: 16,
    marginLeft: 'auto',
    // paddingTop: 10,
    right: 20,
  },
  applyFiltersText: {
    color: denim,
  },
  buttonWidth: {
    // @ts-expect-error TS(2322): Type '"fit-content"' is not assignable to type 'Di... Remove this comment to see the full error message
    width: 'fit-content',
  },

  viewContainer: {
    flexDirection: 'row',
  },
  verticalContainer: {
    flexDirection: 'column',
  },
  radioButtonsContainer: {
    flexDirection: 'column',
    marginHorizontal: 20,
  },
  popovetTextTitle: {
    fontWeight: platformConfig.select({ios: '600', android: 'bold'}),
  },
  filtersButtonContainer: {
    marginTop: 10,
  },
});
